module.exports = "<header>\r\n  <app-landing-header *ngIf=\"!isUserLoggedIn()\" ></app-landing-header>\r\n  <app-home-header *ngIf=\"isUserLoggedIn()\" ></app-home-header>\r\n</header>"


//////////////////
// WEBPACK FOOTER
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/modules/header/header.component.html
// module id = ../../../../../src/app/core/modules/header/header.component.html
// module chunks = main